"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;
var _Popover = _interopRequireWildcard(require("./index.parts"));
exports.Popover = _Popover;